// Gatsby requirements
import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'

// Styles
import * as CSS from './sectionTestimonial.module.scss'

const SectionTestimonial = ({ blok }) => {

    return (
        <section
            className={CSS.section}
            id={blok.anchorId}
            style={{
                backgroundColor: blok.backgroundColor,
                paddingTop: blok?.removeTopMargin ? '0.5rem' : null,
                paddingBottom: blok?.removeBottomMargin ? '0.5rem' : null
            }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">
                <div className={CSS.image}>
                    {blok.image.filename &&
                        <img
                            src={blok.image.filename}
                            loading="lazy"
                            width={blok.image.filename.split('/')[5].split('x')[0]}
                            height={blok.image.filename.split('/')[5].split('x')[1]}
                            alt={blok.image.alt}
                        />
                    }
                </div>
                {blok.richtext &&
                    <div className={`${CSS.text} ${blok.backgroundColor === '#f1f1ef' ? CSS.white : ''}`}>
                        <RichTextRenderer data={blok.richtext} />
                    </div>
                }
            </div>

        </section>
    )
}

export default SectionTestimonial